import { $http } from "@/plugins/api";
import { getApiClientUrl } from "@/config/runtimeConfig";

const inflight: Record<string, Promise<unknown> | undefined> = {};
const cache: Record<string, unknown> = {};

export const getLicencesForOrg = async (uuid: string) => {
  if (!uuid) throw new Error("Organisation ID is not provided");

  if (cache[uuid]) return cache[uuid];
  if (inflight[uuid]) return inflight[uuid];

  inflight[uuid] = $http
    .get(`${getApiClientUrl()}/v2/licence/orgs/${uuid}`)
    .then((res) => {
      cache[uuid] = res.data;
      return cache[uuid];
    })
    .finally(() => {
      delete inflight[uuid];
    });

  return inflight[uuid];
};

export const clearLicencesCache = () => {
  Object.keys(cache).forEach((k) => delete cache[k]);
};

export default {
  getLicencesForOrg,
  clearLicencesCache,
};
